var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hangle cell"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 31,
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M20.6575 15.1119C21.1145 14.702 21.1141 14.0234 20.6566 13.614L15.5 9L10.3434 13.614C9.88591 14.0234 9.88546 14.702 10.3425 15.1119C10.7789 15.5034 11.4721 15.5039 11.9093 15.1132L14.3614 12.9212V19.9464C14.3614 20.5283 14.8712 21 15.5 21C16.1288 21 16.6386 20.5283 16.6386 19.9464V12.9212L19.0907 15.1132C19.5279 15.5039 20.2211 15.5034 20.6575 15.1119Z",
    fill: "#CC331E"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedArrow);
export default __webpack_public_path__ + "static/media/red_arrow.d003f3f61b0a771a1e54fb0288680362.svg";
export { ForwardRef as ReactComponent };